import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { AlertCircle, Droplets, UtensilsCrossed, BatteryWarning } from 'lucide-react';
export function EmpathySection() {
  return <section className="py-20 px-6 bg-cream" data-id="element-13">
      <div className="max-w-4xl mx-auto" data-id="element-14">
        <FadeIn data-id="element-15">
          <div className="prose prose-lg md:prose-xl text-gray-800 mx-auto mb-16" data-id="element-16">
            <p className="text-2xl leading-relaxed font-medium mb-6" data-id="element-17">
              Hay un momento de silencio absoluto: es cuando cierras la puerta
              del consultorio o abres ese sobre de laboratorio y sientes que el
              mundo se detiene. Ese miedo a "lo que viene después", a perder tu
              independencia o a convertirte en una carga para tu familia, no se
              explica con palabras.
            </p>
            <p className="text-xl leading-relaxed mb-6" data-id="element-18">
              Sé que te sientes solo en esto. Sé que cada vez que bebes un vaso
              de agua o comes algo, te preguntas:{' '}
              <em data-id="element-19">¿Esto me estará haciendo daño?</em> Tus riñones no tienen voz,
              pero hoy su silencio termina. No estás aquí por error; estás aquí
              porque tus filtros te están pidiendo un rescate urgente.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-20">
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-gray-100" data-id="element-21">
            <h3 className="text-3xl md:text-4xl font-bold text-forest mb-8 text-center" data-id="element-22">
              La medicina tradicional suele ser una "espera eterna"
            </h3>
            <p className="text-xl text-center mb-12 text-gray-600" data-id="element-23">
              "Vuelva en 3 meses y vemos cómo siguen los niveles". Pero mientras
              esperas, tus nefronas (los filtros de tu riñón) se siguen
              asfixiando en desechos ácidos.
            </p>

            <h4 className="text-2xl font-bold text-center mb-8" data-id="element-24">
              ¿Sientes esto hoy?
            </h4>

            <div className="grid md:grid-cols-2 gap-8" data-id="element-25">
              <div className="flex gap-4 items-start" data-id="element-26">
                <div className="bg-red-50 p-3 rounded-full text-red-500 shrink-0" data-id="element-27">
                  <BatteryWarning size={28} data-id="element-28" />
                </div>
                <p className="text-lg" data-id="element-29">
                  Esa fatiga pesada que no se quita ni durmiendo 10 horas.
                </p>
              </div>

              <div className="flex gap-4 items-start" data-id="element-30">
                <div className="bg-blue-50 p-3 rounded-full text-blue-500 shrink-0" data-id="element-31">
                  <Droplets size={28} data-id="element-32" />
                </div>
                <p className="text-lg" data-id="element-33">
                  Hinchazón en tobillos o párpados que te hace sentir "inflado".
                </p>
              </div>

              <div className="flex gap-4 items-start" data-id="element-34">
                <div className="bg-yellow-50 p-3 rounded-full text-yellow-600 shrink-0" data-id="element-35">
                  <AlertCircle size={28} data-id="element-36" />
                </div>
                <p className="text-lg" data-id="element-37">
                  Ese sabor amoniacal o metálico en la boca que te quita el
                  sabor de la comida.
                </p>
              </div>

              <div className="flex gap-4 items-start" data-id="element-38">
                <div className="bg-green-50 p-3 rounded-full text-forest shrink-0" data-id="element-39">
                  <UtensilsCrossed size={28} data-id="element-40" />
                </div>
                <p className="text-lg" data-id="element-41">
                  La angustia de no saber qué cocinar sin estresar más a tu
                  cuerpo.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}